export default "__VITE_ASSET__3BUdmTIt__"